import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { createFlight } from "adminApi/TransportFacilityApi/FlightApi.js";
import { validateForm } from "utils/validation";
import { FlightRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import fields from "../json/FlightFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import FlightForm from "./components/FlightForm";

const AddFlight = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    const initialValues = useMemo(() => {
        return formdata.reduce((acc, field) => {
            acc[field.name] = "";
            return acc;
        }, {});
    }, [formdata]);

    const {
        values,
        errors,
        handleChange,
        setErrors,
    } = useFormChange(initialValues, FlightRules);

    const { loading, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await createFlight({ data: formValues });
        },

        (vals) => {
            const err = validateForm(vals, FlightRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Flight Added Successfully"
    );

    return (
        <>
            {loading && <Spinner isSpinner />}
            <FlightForm
                title="Add Flight"
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loading}
                btnLabel="Create"
            />
        </>
    );
};

export default AddFlight;